import type {
  PatientInfoApi,
  SessionDownloadLinkApi,
  NotesApi,
  NotesUpdateQuery,
  UpdatePatientInfoQueryApi,
  SessionApiUpdateQuery,
  SessionApiRegisterQuery,
  SessionsSummaryApi,
  SessionApi,
} from "@/Modules/Models/Api/ClinicalHistory";

import { get2, patch2, post2 } from "./utils/FunctionalTherapyApi";

export async function getPatient(customerId: string): Promise<PatientInfoApi> {
  return get2<void, PatientInfoApi>(`/v1.0/users/${customerId}/clinical_history/patient`);
}

export async function updatePatientInfo(
  customerId: string,
  patientInfoId: string,
  info: Partial<UpdatePatientInfoQueryApi>
): Promise<PatientInfoApi> {
  return patch2<Partial<UpdatePatientInfoQueryApi>, PatientInfoApi>(
    `/v1.0/users/${customerId}/clinical_history/patient/${patientInfoId}`,
    info
  );
}

export async function getSessions(uuid: string): Promise<SessionsSummaryApi> {
  return get2<void, SessionsSummaryApi>(
    `/v1.0/clients/${uuid}/clinical_history/sessions`,
    undefined,
    undefined,
    {
      raw: true,
    }
  );
}

export async function getSessionById(uuid: string, sessionId: string): Promise<SessionApi> {
  return get2<void, SessionApi>(`/v1.0/clients/${uuid}/clinical_history/sessions/${sessionId}`);
}

export function getSessionDownloadLink(uuid: string, sessionUuid: string): Promise<SessionDownloadLinkApi> {
  return get2<string, SessionDownloadLinkApi>(`/v1.0/clients/${uuid}/clinical_history/${sessionUuid}/pdf`);
}

export async function getNotes(uuid: string): Promise<NotesApi> {
  return get2<void, NotesApi>(`/v1.0/clients/${uuid}/clinical_history/notes`);
}

export async function registerSession(uuid: string, info: SessionApiRegisterQuery): Promise<SessionApi> {
  return await post2<SessionApiRegisterQuery, SessionApi>(
    `/v1.0/clients/${uuid}/clinical_history/sessions`,
    info
  );
}

export async function updateSession(
  uuid: string,
  sessionId: string,
  info: SessionApiUpdateQuery
): Promise<SessionApi> {
  return await patch2<SessionApiUpdateQuery, SessionApi>(
    `/v1.0/clients/${uuid}/clinical_history/sessions/${sessionId}`,
    info
  );
}

export async function updateNotes(uuid: string, noteId: string, notes: string): Promise<NotesApi> {
  return patch2<NotesUpdateQuery, NotesApi>(`/v1.0/clients/${uuid}/clinical_history/notes/${noteId}`, {
    notes,
  });
}
